import React from "react";
import { Box } from "../elements/Box";
import { Button } from "../elements/Button";
import { Flex } from "../elements/Flex";
import { Grid } from "../elements/Grid";
import { Heading } from "../elements/Heading";
import { Image } from "../elements/Image";
import { Text } from "../elements/Text";
import SectionHeader from "./SectionHeader";

const ImageTextSection = ({
  header,
  title,
  description,
  cta,
  path,
  textAlign = "left",
  reverse,
  img = "https://www.proudtocaredevon.org.uk/wp-content/uploads/sites/4/2021/08/y9DpT.jpg",
  children,
  px = 3,
  pb,
  pt,
  py = [4, 4, 5],
  color,
  alignItems = "center",
  absoluteImg,
  columns = "1fr 1fr",
  roundedImg,
  imgStyle,
}) => {
  return (
    <Grid
      display={["block", "block", "grid"]}
      maxWidth="1100px"
      margin="0 auto"
      gridTemplateColumns={columns}
      gridGap={[4, 4, 5]}
      px={px}
      py={py}
      pt={pt || py}
      pb={pb || py}
      overflow="hidden"
    >
      <Box>
        <Flex height="100%" flexDirection="column">
          {header}

          <Flex height="100%" alignItems={alignItems}>
            <SectionHeader
              title={title}
              description={description}
              textAlign={textAlign}
              cta={cta}
              path={path}
              color={color}
              my={0}
            >
              {children}
            </SectionHeader>
          </Flex>
        </Flex>
      </Box>

      <Flex position="relative" style={{ order: reverse ? -1 : 0 }} mt={[3, 3, 0]}>
        <Image
          borderRadius={roundedImg && "10px"}
          position={absoluteImg && "absolute"}
          mt={absoluteImg && [3, 3, 0]}
          src={img}
          width="100%"
          style={imgStyle || {}}
        />
      </Flex>
    </Grid>
  );
};

export default ImageTextSection;
